import { ActivateReq, FindPasswordReq, LoginReq, ResendVerificationReq, SignUpReq } from '../dto/ReqDtoRepository';
import { AuthResponse, SimpleStringResponse } from '../dto/ResDtoRepository';
import { publicApi, handleApiError, sendApiRequest, withCookieApi } from './apiConfig';

export const convertHandleToAui = async (data: string): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.get<SimpleStringResponse>(`/api/v1/auth/convert-handle?handle=${data}`);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const convertAuiToHandle = async (data: string): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.get<SimpleStringResponse>(`/api/v1/auth/convert-aui?aui=${data}`);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const checkEmail = async (data: string): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.get<SimpleStringResponse>(`/api/v1/auth/check-email?email=${data}`);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const checkHandle = async (data: string): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.get<SimpleStringResponse>(`/api/v1/auth/check-handle?handle=${data}`);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const signUp = async (data: SignUpReq): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.post<SimpleStringResponse>('/api/v1/auth/signin', data);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

// 백엔드에서 보내주는 refreshToken 세팅해야한다
export const login = async (data: LoginReq): Promise<AuthResponse> => {
  try {
    const response = await withCookieApi.post<AuthResponse>('/api/v1/auth/login', data);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

// 백엔드에서 보내주는 expired 된 refreshToken 세팅해야한다
export const logout = async (): Promise<SimpleStringResponse> => {
  try {
    const response = await withCookieApi.post<SimpleStringResponse>('/api/v1/auth/logout');
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

// refreshToken을 보내야 한다
export const refresh = async (): Promise<SimpleStringResponse> => {
  try {
    const response = await withCookieApi.post<SimpleStringResponse>('/api/v1/auth/refresh');
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

// 백엔드에서 보내주는 refreshToken 세팅해야한다
export const activate = async (data: ActivateReq): Promise<AuthResponse> => {
  try {
    const response = await withCookieApi.post<AuthResponse>('/api/v1/auth/activate', data);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const deferredSignup = async (data: SignUpReq): Promise<SimpleStringResponse> => {
  try {
    const response = await publicApi.post<SimpleStringResponse>(`/api/v1/auth/deferred-signup`, data);
    return {
      ...response.data
    };
  } catch (error) {
    throw handleApiError(error);
  }
};

export const resendVerification = async (data: ResendVerificationReq): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('put', '/api/v1/auth/resend-verification', data);
};

export const findPassword = async (data: FindPasswordReq): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('post', '/api/v1/auth/find-pw', data);
};

export const resetPassword = async (data: ActivateReq): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('put', '/api/v1/auth/reset-pw', data);
};